module.exports = __webpack_public_path__ + "img/logo_mobile_apps.73a2b910.png";